import React, { useContext } from 'react';
import { AuthContext } from '../context/auth';


const mystyle = {
  marginLeft: '0.0rem',
  background: "#fff",
  borderTop: "1px solid #dee2e6",
  color: "#869099",
  padding: "1rem"
};

const Footer = () => {

  const { user } = useContext(AuthContext);
  const fecha = new Date();
  const añoActual = fecha.getFullYear();

  const footer = (
    <footer className="main-footer row" style={mystyle}>
      {/* final de todo */}
      <div className='row col-md-12 container-fluid' style={{ height: '40vh', margin: '10px' }}>
        <div className='col-md-4' style={{ margin: 0, padding: 20 }}>
          <span>Ubicanos.</span>
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3934.455172991574!2d-69.20795868592606!3d9.555973383145387!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e7dc18e1379438d%3A0xa16826173e46df0c!2sSYGRECA!5e0!3m2!1ses!2sve!4v1654258932415!5m2!1ses!2sve" style={{ width: '100%', height: '100%' }} className='google-map' allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

        </div>
        <div className='col-md-4 row ' style={{ margin: 0, padding:'20px 0 0 20px' }}>
        
          <ul className=" mx-auto" style={{ margin: 0 }}>
          <legend className='text-left'>Redes Sociales</legend>
            <li ><a href='#'>redes sociales</a></li>
            <li ><a href='#'>redes sociales</a></li>
            <li ><a href='#'>redes sociales</a></li>
            <li ><a href='#'>redes sociales</a></li>
            <li ><a href='#'>redes sociales</a></li>
          </ul>
        </div>
        <div className='col-md-4 row ' style={{ margin: 0, padding:'20px 0 0 20px' }}>
        
        <ul className=" mx-auto" style={{ margin: 0 }}>
        <legend className='text-left'>Redes Sociales</legend>
          <li ><a href='#'>redes sociales</a></li>
          <li ><a href='#'>redes sociales</a></li>
          <li ><a href='#'>redes sociales</a></li>
          <li ><a href='#'>redes sociales</a></li>
          <li ><a href='#'>redes sociales</a></li>
        </ul>
      </div>
      </div>
      <strong className='text-center'>{'Copyright © ' + añoActual  }<a href="#">Sygreca</a>. Todos los Derechos Reservados.</strong>


    </footer>

  )

  return footer;

}

export default Footer


// WEBPACK FOOTER //
// ./src/components/Footer.js